const TYPE_EMPLOYEE = "employee";
const TYPE_OPERATOR = "operator";

export default {
  TYPE_EMPLOYEE: TYPE_EMPLOYEE,
  TYPE_OPERATOR: TYPE_OPERATOR,
};
